export const PERMS = {
  "cari:read": ["admin", "yonetici", "satis", "muhasebe"],
  "cari:write": ["admin", "yonetici", "satis"],
  "siparis:read": ["admin", "yonetici", "satis", "muhasebe", "depo", "uretim"],
  "siparis:create": ["admin", "yonetici", "satis"],
  "siparis:cancel": ["admin", "yonetici"],
  "siparis:approve": ["admin", "yonetici", "satis"],
  "siparis:sevk": ["admin", "yonetici", "depo"],
  "stok:read": ["admin", "yonetici", "depo", "uretim", "satis", "muhasebe"],
  "stok:write": ["admin", "yonetici", "depo"],
  "recete:read": ["admin", "yonetici", "muhasebe", "uretim"],
  "uretim:read": ["admin", "yonetici", "uretim", "satis", "depo"],
  "uretim:plan": ["admin", "yonetici", "uretim"],
  "uretim:islem": ["admin", "yonetici", "uretim", "depo", "istasyon"],
  "sablon:write": ["admin", "yonetici"],
  "tahsilat:read": ["admin", "yonetici", "muhasebe", "satis"],
  "tahsilat:write": ["admin", "yonetici", "muhasebe", "satis"],
  "tahsilat:manage": ["admin", "yonetici", "muhasebe"],
  "sevkiyat:read": ["admin", "yonetici", "depo", "satis", "muhasebe"],
  "satinalma:read": ["admin", "yonetici", "depo", "muhasebe", "uretim"],
  "satinalma:write": ["admin", "yonetici", "muhasebe"],
  "satinalma:kabul": ["admin", "yonetici", "depo"],
  "fatura:read": ["admin", "yonetici", "muhasebe"],
  "fatura:write": ["admin", "yonetici", "muhasebe"],
  "odeme:read": ["admin", "yonetici", "muhasebe"],
  "odeme:write": ["admin", "yonetici", "muhasebe"],
  "ozet:read": ["admin", "yonetici", "muhasebe"],
  "hesap:read": ["admin", "yonetici", "muhasebe"],
  "hesap:write": ["admin", "yonetici", "muhasebe"],
  "gider:read": ["admin", "yonetici", "muhasebe"],
  "gider:write": ["admin", "yonetici", "muhasebe"],
  "proje:read": ["admin", "yonetici", "muhasebe"],
  "proje:write": ["admin", "yonetici", "muhasebe"],
  maliyet: ["admin", "yonetici", "muhasebe"],
};

export const can = (user, action) => !!user && (PERMS[action] || []).includes(user.role);

export const DURUM = {
  onay_bekliyor: ["Onay bekliyor", "bg-amber-500/15 text-amber-300 border-amber-500/30"],
  onaylandi: ["Onaylandı", "bg-sky-500/15 text-sky-300 border-sky-500/30"],
  uretimde: ["Üretimde", "bg-violet-500/15 text-violet-300 border-violet-500/30"],
  sevke_hazir: ["Sevke hazır", "bg-emerald-500/15 text-emerald-300 border-emerald-500/30"],
  sevk_ediliyor: ["Sevk ediliyor", "bg-emerald-500/15 text-emerald-300 border-emerald-500/30"],
  stok_kontrol: ["Stok kontrol", "bg-violet-500/15 text-violet-300 border-violet-500/30"],
  sevk_edildi: ["Sevk edildi", "bg-white/10 text-white/80 border-white/20"],
  gelen: ["Kabul bekliyor", "bg-amber-500/15 text-amber-300 border-amber-500/30"],
  kabul_ediliyor: ["Kabul ediliyor", "bg-amber-500/15 text-amber-300 border-amber-500/30"],
  arsiv: ["KolayBi arşivi", "bg-white/5 text-white/70 border-white/15"],
  reddedildi: ["Reddedildi", "bg-red-500/15 text-red-300 border-red-500/30"],
  iptal: ["İptal", "bg-red-500/10 text-red-300/70 border-red-500/20"],
};

export const UYARI = {
  risk_asimi: "Risk limiti aşımı",
  min_fiyat_alti: "Minimum fiyatın altında",
  termin_riski: "Termin riski",
};

export const CARI_TIP = { musteri: "Müşteri", tedarikci: "Tedarikçi", her_ikisi: "Müşteri / Tedarikçi", yurt_disi: "Yurt Dışı", broker: "Broker", kamu: "Kamu Kuruluşu", musteri_nakliyeci: "Müşteri / Nakliyeci", ogrenci: "Öğrenci", taseron: "Taşeron", personel: "Personel" };
export const IE_DURUM = {
  uretimde: ["Üretimde", "bg-violet-500/15 text-violet-300 border-violet-500/30"],
  karar_bekliyor: ["Şef kararı bekliyor", "bg-amber-500/15 text-amber-300 border-amber-500/30"],
  tamamlaniyor: ["Tamamlanıyor", "bg-sky-500/15 text-sky-300 border-sky-500/30"],
  tamamlandi: ["Tamamlandı", "bg-emerald-500/15 text-emerald-300 border-emerald-500/30"],
  iptal: ["İptal", "bg-red-500/10 text-red-300/70 border-red-500/20"],
};
export const DUYURU_TIP = { yeni_urun: "Yeni ürün", kampanya: "Kampanya", fiyat: "Fiyat değişikliği", genel: "Duyuru" };
export const TAHSIL_DURUM = {
  tahsil_edildi: ["Tahsil edildi", "bg-emerald-500/15 text-emerald-300 border-emerald-500/30"],
  portfoyde: ["Portföyde", "bg-amber-500/15 text-amber-300 border-amber-500/30"],
  karsiliksiz: ["Karşılıksız", "bg-red-500/15 text-red-300 border-red-500/30"],
  ciro_edildi: ["Ciro edildi", "bg-sky-500/15 text-sky-300 border-sky-500/30"],
  iptal: ["İptal", "bg-white/5 text-muted-foreground border-white/10"],
};
export const Rozet = ({ map, d, testid }) => {
  const [l, c] = map[d] || [d, "bg-white/5"];
  return <span data-testid={testid} className={`text-[11px] px-2.5 py-0.5 rounded-full border whitespace-nowrap ${c}`}>{l}</span>;
};
export const PARA = ["TRY", "USD", "EUR"];
export const ONAY_KURAL = { siparis_dahil: "Sipariş dahil risk limitine ulaşırsa onaya düşsün", bakiye: "Mevcut bakiye risk limitini aşmışsa onaya düşsün", her_zaman: "Her sipariş onaya düşsün" };
export const SEVK_DURUM = {
  yolda: ["Yolda", "bg-sky-500/15 text-sky-300 border-sky-500/30"],
  teslim_edildi: ["Teslim edildi", "bg-emerald-500/15 text-emerald-300 border-emerald-500/30"],
};
export const FATURA_DURUM = {
  islendi: ["Cariye işlendi", "bg-emerald-500/15 text-emerald-300 border-emerald-500/30"],
  onay_bekliyor: ["Onay bekliyor", "bg-amber-500/15 text-amber-300 border-amber-500/30"],
  reddedildi: ["Reddedildi", "bg-red-500/15 text-red-300 border-red-500/30"],
};
export const CEK_DURUM = {
  bekliyor: ["Vadesi bekleniyor", "bg-sky-500/15 text-sky-300 border-sky-500/30"],
  odendi: ["Bankadan ödendi", "bg-emerald-500/15 text-emerald-300 border-emerald-500/30"],
  karsiliksiz: ["Karşılıksız / iade", "bg-red-500/15 text-red-300 border-red-500/30"],
};
export const SA_DURUM = {
  acik: ["Bekleniyor", "bg-sky-500/15 text-sky-300 border-sky-500/30"],
  kismi: ["Kısmi geldi", "bg-amber-500/15 text-amber-300 border-amber-500/30"],
  tamamlandi: ["Tamamlandı", "bg-emerald-500/15 text-emerald-300 border-emerald-500/30"],
  iptal: ["İptal", "bg-red-500/10 text-red-300/70 border-red-500/20"],
};
